export default "__VITE_ASSET__C9APuOS1__"